// A5/B6 — one gene symbol resolved against the registry, cached per symbol (registryResolution.ts).
// A null symbol asks nothing; `unknown` means the registry could not answer, never "resolved".
import { useEffect, useState } from "react";

import { SymbolResolution, resolveSymbolInRegistry } from "../../../../utils/geneCodes/registryResolution";

export type SymbolResolutionState = SymbolResolution | { state: "loading" };

export const useSymbolResolution = (symbol: string | null): SymbolResolutionState | null => {
	const [resolution, setResolution] = useState<SymbolResolutionState | null>(null);

	useEffect(() => {
		if (!symbol) {
			setResolution(null);
			return undefined;
		}

		let live = true;
		setResolution({ state: "loading" });
		void resolveSymbolInRegistry(symbol).then((result) => {
			if (live) setResolution(result);
		});

		return () => {
			live = false;
		};
	}, [symbol]);

	return symbol ? resolution : null;
};
